import { AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventoUnidad} from '../../../../_models/evento-unidad';
import { UnidadEtapasService} from '../_services/unidad-etapas.service';
import { GapiPickerService} from '../../../../_services/gapi-picker';

@Component({
    selector: 'unidad-evento-detalle',
    standalone: false,
    templateUrl: 'unidad-evento-detalle.component.html',
    styleUrls: ['unidad-evento-detalle.component.scss','../../unidad-etapas/unidad-etapas-generales.scss']
})

export class UnidadEventoDetalleComponent implements OnInit, AfterViewInit {

    eventoUnidad: EventoUnidad;
    materiasDisponibles;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private unidadEtapasService: UnidadEtapasService,
                private pickerService: GapiPickerService) {
    }

    ngOnInit() {
        this.eventoUnidad = this.data.evento;
        this.materiasDisponibles = this.unidadEtapasService.getMaterias();

        this.eventoUnidad.eventoMaterias.map(eventoMateria => {
            const materia = this.materiasDisponibles.find(mat => mat.id == eventoMateria.materiaCursoPeriodoID),
                str = materia ? `${materia.nombreCompleto}` : 'N/A';
            eventoMateria['nombre'] = str;
        });
    }

    ngAfterViewInit() {
        if (this.eventoUnidad.evento.categoriaID == 81) {

            this.pickerService.createAdvancedClassRoomButton(
                'classroomshare',
                {
                    title: this.eventoUnidad.evento.nombre,
                    body: this.eventoUnidad.evento.resumenTXT
                }
            );
        }
    }
}
